import React, {memo, useMemo} from "react";
import {Box, Grid, Skeleton, Typography} from "@mui/material";
import CardActionArea from "@mui/material/CardActionArea";
import ProductGroup, {ProductGroupLevel} from "@/types/product-group";
import PictureWithBlur from "@/components/utilities/picture-with-blur";
import CustomSwiper from "@/components/common/slider/custom-swiper";
import {PATHS} from "@/utils/paths";
import {brandModels, carModels} from "@/constants/card-company";
import Link from "next/link";


export const SkeletonSwiper = () => (
    <Skeleton width = "100%" height = "100%" variant = "rectangular" animation = "wave" />
);

export const getSortedProducts = (filtered: ProductGroup[], car: boolean) => {
    const modelOrder = car ? carModels : brandModels;
    return [...filtered].filter(item => modelOrder.includes(item.name)).sort((a, b) => modelOrder.indexOf(a.name) - modelOrder.indexOf(b.name));
};

export default function CarAndCompanySlider({

                                                noName,
                                                targetLevel,
                                                countInDesktop = 9,
                                                car,
                                                productGroups

                                            }: {
    targetLevel: ProductGroupLevel;
    noName?: boolean;
    car?: boolean;
    countInDesktop?: number;
    selectedCategoriesSection: string;
    productGroups?: ProductGroup[];

}) {
    const filteredProductGroups = useMemo(() => {
        if (!Array.isArray(productGroups)) return [];
        return car ? productGroups.filter(item => item?.name && carModels.includes(item.name))
            : productGroups.filter(item => item?.pLevel === targetLevel).slice(0, countInDesktop);
    }, [productGroups, targetLevel, car, countInDesktop]);

    const sortedProducts = useMemo(() => getSortedProducts(filteredProductGroups, !!car), [filteredProductGroups, car]);

    const ItemCard = memo(({item}: { item: ProductGroup }) => (
        <CardActionArea
            sx = {{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                ".MuiCardActionArea-focusHighlight": {
                    background: !car ? "transparent" : undefined,
                },
            }}
        >
            <Box
                component = {Link}
                href = {item.pLevel === ProductGroupLevel.Car
                    ? `${PATHS.GENERAL.PRODUCTS}?Car=${item.id}&Page=1&SortOrder=2&isExists=true`
                    : `${PATHS.GENERAL.PRODUCTS}?Company=${item.id}&Page=1&SortOrder=2&isExists=true`
                }
                p = "0 0 3px 0 !important"
                textAlign = "center"
            >
                <PictureWithBlur src = {item.picture} width = {85} height = {85} alt = {item.name} />

                {!noName && (
                    <Typography variant = "h6" fontSize = {16} fontWeight = {300} sx = {{mt: 0}} >
                        {item.name}
                    </Typography >
                )}
            </Box >
        </CardActionArea >
    ));


    return (
            <Grid container spacing = {2} >
                <Grid item xs = {12} sx = {{px: `0 !important`}} >
                    {!productGroups ? (
                            <SkeletonSwiper />
                        ) :
                        <CustomSwiper
                            items = {sortedProducts.map(item => <ItemCard key = {item.id} item = {item} />)}
                            clickable = {false}
                            navigation = {false}
                            grid = {0}
                            auto
                            mode="auto"
                            slideMinWidth={100}
                            slideMaxWidth={130}
                            slideFluidWidth="30vw"
                        />
                    }
                </Grid >
            </Grid >
    );
};
